import onPrepareFields from './chains/onPrepareFields'
import withInitialize from '../app/factories/withInitialize'
import uploadProgress from './chains/uploadProgress'
import uploadDone from './chains/uploadDone'
import uploadError from './chains/uploadError'
import saveAccount from './chains/saveAccount'
import logout from './chains/logout'
import unShowSaveUserSnackbar from './chains/unShowSaveUserSnackbar'
import copyFromPreviousFields from './chains/copyFromPreviousFields'
import getUsers from './chains/getUsers'
import getUnapprovedUsers from './chains/getUnapprovedUsers'
import prepareNewUser from './chains/prepareNewUser'
import onPrepareFieldsForEditUser from './chains/onPrepareFieldsForEditUser'
import deleteUser from './chains/deleteUser'
import askUserDelete from './chains/askUserDelete'
import preventDelete from './chains/preventDelete'
import changeSort from './chains/changeSort'
import changeToUnapprovedUsers from './chains/changeToUnapprovedUsers'
import changeToApprovedUsers from './chains/changeToApprovedUsers'
import performSearch from './chains/performSearch'
import selectSearchOption from './chains/selectSearchOption'
import onFilterChange from './chains/onFilterChange'
import unshowLatestSearchSnackbar from './chains/unshowLatestSearchSnackbar'
import fetchUsers from './chains/fetchUsers'
import changeModule from './chains/changeModule'
import closeSearchOption from './chains/closeSearchOption'
import openSearchOption from './chains/openSearchOption'
import openNavigation from './chains/openNavigation'
import closeNavigation from './chains/closeNavigation'

export default () => {
  return module => {
    module.addSignals({
      onPrepareFields: withInitialize(onPrepareFields),
      uploadProgress,
      uploadDone,
      uploadError,
      saveAccount,
      logout: withInitialize(logout),
      unShowSaveUserSnackbar,
      copyFromPreviousFields,
      getUsers: withInitialize(getUsers),
      getUnapprovedUsers: withInitialize(getUnapprovedUsers),
      prepareNewUser: withInitialize(prepareNewUser),
      onPrepareFieldsForEditUser: withInitialize(onPrepareFieldsForEditUser),
      deleteUser,
      askUserDelete,
      preventDelete,
      changeSort,
      changeToUnapprovedUsers,
      changeToApprovedUsers,
      performSearch,
      closeSearchOption,
      openSearchOption,
      selectSearchOption,
      onFilterChange,
      unshowLatestSearchSnackbar,
      fetchUsers,
      changeModule,
      openNavigation,
      closeNavigation
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/index.js